import { DataSourceStrategy } from '@rammetec/data-access';
/** Business entities — servable via Firestore and PostgresRest (/pg/v1). */
export const BUSINESS_ALLOWED_DATA_SOURCES = [
    DataSourceStrategy.Firestore,
    DataSourceStrategy.PostgresRest,
    DataSourceStrategy.RestScript,
];
/**
 * Default `repositoryConfig.dataSource` for business entities.
 * Orgs may still override via `config-repository`; keep Firestore in
 * `BUSINESS_ALLOWED_DATA_SOURCES` for that path.
 */
export const BUSINESS_DEFAULT_DATA_SOURCE = DataSourceStrategy.PostgresRest;
/** System entities — Firestore only. */
export const SYSTEM_ALLOWED_DATA_SOURCES = [DataSourceStrategy.Firestore];
//# sourceMappingURL=dataSourcePolicy.js.map